module.exports = __webpack_public_path__ + "static/media/mobile-application-security-testing.bd64a671.png";